var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMountains = function SvgMountains(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#24292D",
    d: "M6.18 4.895a.5.5 0 0 1 .867 0l2.365 4.099.954-1.653a.5.5 0 0 1 .813-.076l.053.076 2.774 4.804a.5.5 0 0 1-.433.75H2.427a.5.5 0 0 1-.433-.75zm4.62 3.697-.81 1.402 1.098 1.9 1.62.001L10.8 8.592zM6.613 6.145l-3.32 5.75h6.64l-3.32-5.75zm3.385-3.04a1.572 1.572 0 1 1 0 3.146 1.573 1.573 0 1 1 0-3.146zm0 1a.573.573 0 1 0-.003 1.145.573.573 0 0 0 .003-1.145z"
  })));
};
export default SvgMountains;